import { AxiosResponse } from 'axios';
import { DateTime } from 'luxon';
import { EventError } from 'shell/models/event-error';
import { HttpResponse } from 'shell/models/http-response';

export interface transformTypeEventResponse {
  idPublishedEvent?: number;
  idJms?: string;
  idConsummedEvent?: number;
  dateTimePublication: DateTime | null;
  eventTypeCode?: string;
  destinationTypeCode?: string;
  subscriber?: string;
  eventData?: string;
  progressive?: number;
  dateTimeConsumationStart: DateTime | null;
  dateTimeConsumationEnd: DateTime | null;
  attemptsNumber?: number;
  eventDescription?: string;
  state?: string;
  outcome?: string;
  destinationTypeDescription?: string;
  subscriberDescription?: string;
}

export const transformEventError = (
  response: AxiosResponse<HttpResponse<EventError>>
): transformTypeEventResponse => {
  const data: EventError = response.data.payload || {};
  const res: transformTypeEventResponse = {
    idPublishedEvent: data?.idEventoPubblicato,
    idConsummedEvent: data?.id,
    eventDescription: data?.descrizioneTipoEvento,
    dateTimePublication: data?.dataOraPubblicazione
      ? DateTime.fromISO(data?.dataOraPubblicazione)
      : null,
    attemptsNumber: data?.numeroRollbackEffettuati,
    dateTimeConsumationStart: data?.inizioElaborazione
      ? DateTime.fromISO(data?.inizioElaborazione)
      : null,
    dateTimeConsumationEnd: data?.fineElaborazione
      ? DateTime.fromISO(data?.fineElaborazione)
      : null,
    destinationTypeCode: data?.codiceTipoDestinazione?.toString() || '',
    eventData: data?.datiEvento || '',
    outcome: data?.esito || '',
    state: data?.statoElaborazione || '',
    eventTypeCode: data?.codiceTipoEvento || '',
    progressive: data?.progressivo,
    subscriber: data?.codiceSottoscrittore.toString() || '',
    idJms: data?.idJms,
    destinationTypeDescription: data?.descrizioneTipoDestinazione || '',
    subscriberDescription: data?.descrizioneSottoscrittore || '',
  };
  return res;
};
